"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSFORMATION_DB_TYPE = exports.TRANSFORMATION_AGGREGATION_PERIOD = void 0;
var TRANSFORMATION_AGGREGATION_PERIOD;
(function (TRANSFORMATION_AGGREGATION_PERIOD) {
    TRANSFORMATION_AGGREGATION_PERIOD["INSTANT"] = "INSTANT";
    TRANSFORMATION_AGGREGATION_PERIOD["HOURLY"] = "HOURLY";
    TRANSFORMATION_AGGREGATION_PERIOD["DAILY"] = "DAILY";
    TRANSFORMATION_AGGREGATION_PERIOD["WEEKLY"] = "WEEKLY";
    TRANSFORMATION_AGGREGATION_PERIOD["MONTHLY"] = "MONTHLY";
})(TRANSFORMATION_AGGREGATION_PERIOD || (exports.TRANSFORMATION_AGGREGATION_PERIOD = TRANSFORMATION_AGGREGATION_PERIOD = {}));
var TRANSFORMATION_DB_TYPE;
(function (TRANSFORMATION_DB_TYPE) {
    TRANSFORMATION_DB_TYPE["POSTGRES"] = "POSTGRES";
    TRANSFORMATION_DB_TYPE["BIGQUERY"] = "BIGQUERY";
})(TRANSFORMATION_DB_TYPE || (exports.TRANSFORMATION_DB_TYPE = TRANSFORMATION_DB_TYPE = {}));
